import axiosInstance from './axiosInstance';
import {
  IOrganisation,
  IUpdateOrganisationPayload,
  IOrganisationListParams,
  IAddress,
} from '../interfaces';

class OrganisationService {
  private static instance: OrganisationService;
  private constructor() {}

  public static getInstance(): OrganisationService {
    if (!OrganisationService.instance) {
      OrganisationService.instance = new OrganisationService();
    }
    return OrganisationService.instance;
  }

  public async getOrganisation(
    organisationId: string,
    params?: IOrganisationListParams
  ): Promise<IOrganisation> {
    try {
      const response = await axiosInstance.get<IOrganisation>(
        `/organisations/${organisationId}`,
        { params }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch organisation data');
    }
  }

  public async updateOrganisation(
    organisationId: string,
    payload: IUpdateOrganisationPayload,
    params?: IOrganisationListParams
  ): Promise<IOrganisation> {
    try {
      const response = await axiosInstance.put<IOrganisation>(
        `/organisations/${organisationId}`,
        payload,
        { params }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to update organisation');
    }
  }

  public async updateOrganisationAddress(
    organisationId: string,
    address: IAddress,
    params?: IOrganisationListParams
  ): Promise<IOrganisation> {
    try {
      const payload = { address };
      const response = await axiosInstance.patch<IOrganisation>(
        `/organisations/${organisationId}/address`,
        payload,
        { params }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to update organisation address');
    }
  }
}

export default OrganisationService.getInstance();

